/* eslint-disable jira/filename-case */
import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages';

export function AuditLogGraphic() {
	const { formatMessage } = useIntl();
	return (
		<svg
			width="387"
			height="276"
			viewBox="0 0 387 276"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				width="200"
				height="244"
				transform="matrix(0.997242 -0.0742187 0.0655601 0.997849 0 15.8682)"
				fill="#1868DB"
			/>
			<rect
				x="172.24"
				y="13.9958"
				width="193"
				height="243"
				transform="rotate(1.512 172.24 13.9958)"
				fill="#FCA700"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M200.349 14.738L215.445 244.499L166.059 248.175L172.24 13.9961L200.349 14.738Z"
				fill="#09326C"
			/>
			<rect width="284" height="185" transform="translate(41 40)" fill="white" />
			<rect width="284" height="56" transform="translate(41 40)" fill="white" />
			<g clip-path="url(#clip0_1210_17850)">
				<g clip-path="url(#clip1_1210_17850)">
					<g clip-path="url(#clip2_1210_17850)">
						<g clip-path="url(#clip3_1210_17850)">
							<path
								d="M67.2752 72.3371H65.6108C63.1006 72.3371 61.2998 70.7996 61.2998 68.5482H70.2492C70.7131 68.5482 71.0132 68.8777 71.0132 69.3444V78.35C68.7758 78.35 67.2752 76.5379 67.2752 74.012V72.3371ZM71.6953 67.8618H70.0309C67.5207 67.8618 65.7199 66.3517 65.7199 64.1003H74.6694C75.1332 64.1003 75.4606 64.4023 75.4606 64.8691V73.8747C73.2233 73.8747 71.6953 72.0626 71.6953 69.5366V67.8618ZM76.1427 63.4139H74.4784C71.9682 63.4139 70.1674 61.8764 70.1674 59.625H79.1168C79.5806 59.625 79.8808 59.9545 79.8808 60.3938V69.3993C77.6434 69.3993 76.1427 67.5872 76.1427 65.0613V63.4139Z"
								fill="#1868DB"
							/>
						</g>
					</g>
				</g>
				<text
					fill="#172B4D"
					xmlSpace="preserve"
					// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
					style={{ whiteSpace: 'pre' }}
					font-size="16"
					fontWeight="590"
					letterSpacing="0px"
				>
					<tspan x="91" y="73.6875">
						{formatMessage(messages.auditLogSvgText)}
					</tspan>
				</text>
			</g>
			<path
				d="M172.823 102.883C171.712 103.725 170.323 104.114 168.937 103.971C167.551 103.829 166.27 103.165 165.354 102.115C164.439 101.064 163.956 99.7051 164.003 98.3123C164.051 96.9194 164.625 95.5966 165.611 94.6111C166.596 93.6256 167.919 93.051 169.312 93.0034C170.705 92.9558 172.064 93.4387 173.114 94.3546C174.165 95.2704 174.828 96.5509 174.971 97.9373C175.114 99.3236 174.725 100.712 173.883 101.823L176.53 104.47C176.823 104.763 177.06 105.06 176.53 105.53C176 106 175.763 105.823 175.47 105.53L172.823 102.883ZM169.5 102.5C170.561 102.5 171.578 102.079 172.328 101.328C173.078 100.578 173.5 99.5609 173.5 98.5C173.5 97.4391 173.078 96.4217 172.328 95.6716C171.578 94.9214 170.561 94.5 169.5 94.5C168.439 94.5 167.422 94.9214 166.671 95.6716C165.921 96.4217 165.5 97.4391 165.5 98.5C165.5 99.5609 165.921 100.578 166.671 101.328C167.422 102.079 168.439 102.5 169.5 102.5Z"
				fill="#B7B9BE"
			/>
			<rect x="135" y="126" width="52" height="9" rx="3" fill="#DDDEE1" />
			<rect x="60.5" y="88.5" width="121" height="23" rx="2.5" stroke="#B3B9C4" />
			<rect x="135" y="150" width="52" height="9" rx="3" fill="#DDDEE1" />
			<rect x="60" y="150" width="66" height="9" rx="3" fill="#CFE1FD" />
			<rect x="60" y="174" width="66" height="9" rx="3" fill="#CFE1FD" />
			<rect x="60" y="198" width="66" height="9" rx="3" fill="#CFE1FD" />
			<rect x="135" y="174" width="52" height="9" rx="3" fill="#DDDEE1" />
			<rect x="135" y="198" width="52" height="9" rx="3" fill="#DDDEE1" />
			<text
				fill="#626F86"
				xmlSpace="preserve"
				// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
				style={{ whiteSpace: 'pre' }}
				font-family="SF Pro"
				font-size="10"
				font-weight="510"
				letter-spacing="0px"
			>
				<tspan x="60" y="132.555">
					May 24, 8am
				</tspan>
			</text>
			<rect x="194" y="126" width="28" height="9" rx="3" fill="#DDDEE1" />
			<rect x="194" y="150" width="28" height="9" rx="3" fill="#DDDEE1" />
			<rect x="194" y="174" width="28" height="9" rx="3" fill="#DDDEE1" />
			<rect x="194" y="198" width="28" height="9" rx="3" fill="#DDDEE1" />
			<rect x="229" y="126" width="70" height="9" rx="3" fill="#DDDEE1" />
			<rect x="229" y="150" width="70" height="9" rx="3" fill="#DDDEE1" />
			<rect x="229" y="174" width="70" height="9" rx="3" fill="#DDDEE1" />
			<rect x="229" y="198" width="70" height="9" rx="3" fill="#DDDEE1" />
			<defs>
				<clipPath id="clip0_1210_17850">
					<rect width="236" height="24" fill="white" transform="translate(59 56)" />
				</clipPath>
				<clipPath id="clip1_1210_17850">
					<rect width="24" height="24" fill="white" transform="translate(59 56)" />
				</clipPath>
				<clipPath id="clip2_1210_17850">
					<rect width="24" height="24" fill="white" transform="translate(59 56)" />
				</clipPath>
				<clipPath id="clip3_1210_17850">
					<rect width="18.581" height="18.725" fill="white" transform="translate(61.2998 59.625)" />
				</clipPath>
			</defs>
		</svg>
	);
}
